import { BADGE_TYPE } from "@propellerads/badge";

import {ApiService, NotixApi} from "Services/api";
import ZoneService, { isInAppZone } from "Services/zones";
import {NotixApiService} from "./api";

export const SITE_STATUS = {
  NOT_VERIFIED: 1,
  REJECTED: 2,
  VERIFIED: 3,
  MODERATED: 4,
};

export const PLACEMENT_TYPE = {
  WEBSITE: "web_site",
  LANDING_PAGE: "landing",
};

export const SITE_DATA = {
  CREATED_AT: "createdAt",
};

class Sites {
  getList() {
    return NotixApi.get("/sites/list")
  }

  checkOnExists(url) {
    return NotixApiService.get(`/sites/exists?url=${url}`).then((result) => {
      return true;
    }).catch(e => {
      return false;
    });
  }

  addSite(placementData) {
    return ApiService.post("/sites/", placementData);
  }

  getSite(id) {
    return ApiService.get(`/sites/${id}/`).then((site) => {
      return {
        ...site,
        rejectReason:
          (site.reject_reason && site.reject_reason.text) || undefined,
        zones: site.zones
          .filter((zone) => !isInAppZone(zone))
          .map((zone) => {
            return ZoneService.prepareZoneToClient(zone);
          }),
      };
    });
  }

  createDirectLinkSite() {
    return ApiService.post(`/sites/direct_link/`).then((site) => {
      return {
        ...site,
        zones: site.zones.map((zone) => {
          return ZoneService.prepareZoneToClient(zone);
        }),
      };
    });
  }

  getDirectLinkSite() {
    return ApiService.get(`/sites/direct_link/`).then((sites) => {
      if (sites?.length === 0) {
        return this.createDirectLinkSite();
      }

      const zones = [];
      sites.forEach((site) => {
        if (site.zones.length > 0) {
          zones.push(
            ...site.zones.map((zone) => {
              return ZoneService.prepareZoneToClient(zone);
            })
          );
        }
      });

      return {
        ...sites[0],
        zones,
      };
    });
  }

  getStatusTitle(status) {
    switch (status) {
      case SITE_STATUS.NOT_VERIFIED:
        return "sites_list-status-not-verified";
      case SITE_STATUS.REJECTED:
        return "sites_list-status-rejected";
      case SITE_STATUS.VERIFIED:
        return "sites_site-status-verified";
      case SITE_STATUS.MODERATED:
        return "sites_site-status-moderation";
      default:
        return "";
    }
  }

  getStatusColor(status) {
    switch (status) {
      case SITE_STATUS.NOT_VERIFIED:
        return BADGE_TYPE.WARNING;
      case SITE_STATUS.REJECTED:
        return BADGE_TYPE.DANGER;
      case SITE_STATUS.VERIFIED:
        return BADGE_TYPE.SUCCESS;
      case SITE_STATUS.MODERATED:
        return BADGE_TYPE.INFO;
      default:
        return "";
    }
  }
}

const sitesInstance = new Sites();

export default sitesInstance;